import api from '../../api'
import {
    SET_MARKETSTUDY_AD_COMPARABLES
} from '../../constants'

const default_state = {
    ad_comparables: {}
}
const state = default_state


const actions = {
    FETCH_MARKETSTUDY_AD_COMPARABLES: ({state, commit, rootState}, data) => {
        return api.get({path: data.path})
            .then((res) => {
                // console.log(res)
                if (!res){
                    res = {'0': {'id': 'default', 'adopted_area': 0, 'offer_price': 0, 'offer_unit_price': 0}}
                }
                commit(SET_MARKETSTUDY_AD_COMPARABLES, res)
            })
    },
    SET_MARKETSTUDY_AD_COMPARABLES: ({state, commit, rootState}, data) => {
        commit(SET_MARKETSTUDY_AD_COMPARABLES, data)
    },
    UPDATE_MARKETSTUDY_AD_COMPARABLES: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: false})
            .then((res) => {

            })
    }

}

const mutations = {
    [SET_MARKETSTUDY_AD_COMPARABLES] (state, data) {
        state.ad_comparables = check_undefined(data)
    }
}

const getters = {
    marketstudy_ad_comparables: state => {
        return state.ad_comparables
    }
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/marketstudy/marketstudy_ad_comparables.js